export default class VideoFullwidth {
	private root: HTMLElement
	private video: HTMLVideoElement | null = null
	private overlay: HTMLButtonElement | null = null
	private bound = false

	constructor(root: HTMLElement) {
		this.root = root
	}

	init() {
		this.video = this.root.querySelector<HTMLVideoElement>( '.hg-video-fullwidth__video' )
		this.overlay = this.root.querySelector<HTMLButtonElement>( '.hg-video-fullwidth__overlay' )
		if ( ! this.video || ! this.overlay ) {
			return
		}
		this.overlay.addEventListener( 'click', this.onPlayClick )
		this.bound = true
	}

	cleanup() {
		if ( this.bound && this.overlay ) {
			this.overlay.removeEventListener( 'click', this.onPlayClick )
		}
		this.bound = false
	}

	private onPlayClick = async ( e: Event ) => {
		e.preventDefault()
		if ( ! this.video || ! this.overlay ) {
			return
		}
		this.root.classList.add( 'is-playing' )
		this.video.controls = true
		try {
			await this.video.play()
		} catch {
			// Autoplay políticas / interrupción del usuario: ignorar.
		}
	}
}
